import { useSearchParams } from 'react-router-dom';

import { useUser } from '@/features/auth/hooks/use-user';
import {
  AcceptSubprojectInvitationFlow,
  InvitationStatus,
} from '@/features/partners/components/pages/accept-partner-invitation-flow';
import { useGetSubprojectInvitation } from '@/features/partners/hooks/use-get-subproject-invitation';

export const AcceptSubprojectInvitationPage = () => {
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('token');

  const { data: user } = useUser();
  const { data: invitation, isLoading: isInvitationLoading } =
    useGetSubprojectInvitation({
      invitationToken: invitationToken || '',
      enabled: !!invitationToken && !!user,
    });

  return (
    <AcceptSubprojectInvitationFlow
      invitationToken={invitationToken}
      isInvitationLoading={isInvitationLoading}
      status={invitation?.status as InvitationStatus | undefined}
      project={invitation?.project}
      toEmail={invitation?.to_email}
      kpisIds={invitation?.kpis_ids}
    />
  );
};
